import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1696c998"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "sticky-cta__border" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "sticky-cta__inner" }, [
        /*#__PURE__*/ _createElementVNode("span", null, "Talk to us")
    ])
], -1));
const _hoisted_3 = [
    _hoisted_2
];
export default /*#__PURE__*/ _defineComponent({
    __name: 'sticky_cta',
    props: {
        d: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("a", {
                href: _ctx.d.link,
                class: "sticky-cta"
            }, _hoisted_3, 8, _hoisted_1));
        };
    }
});
